import { companyApis } from '@apis/dashboard/companyApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useCompanyDetail = createUseQuery(
  (id: number) => [`/dashboard/company/${id}/detail/`],
  (id: number) => async () =>
    companyApis
      .get('/dashboard/company/{id}/detail/', {
        path: { id },
      })
      .then((r) => r[200]!),
);
